export interface ProgressResult {
  stage: number;
  progress: number;
  levelUps: number;
}

export interface HitResult {
  stage: number;
  progress: number;
  gameOver: boolean;
}

/**
 * Trúng Hazard:
 * - Stage 0 (TINY) → game over
 * - Khác: stage -1, progress reset = progressOnHit ở stage MỚI
 */
export function applyHit(startStage: number, progressOnHit: number): HitResult {
  if (startStage <= 0) {
    return { stage: 0, progress: 0, gameOver: true };
  }
  return { stage: startStage - 1, progress: progressOnHit, gameOver: false };
}

/**
 * Apply progress delta với rule:
 * - Mỗi `perStage` progress lên 1 stage
 * - Excess carry over qua stage mới
 * - Cap progress = perStage khi đã ở maxStage (không level up nữa)
 */
export function applyProgress(
  startStage: number,
  startProgress: number,
  delta: number,
  maxStage: number,
  perStage: number,
): ProgressResult {
  let stage = startStage;
  let progress = Math.max(0, startProgress + delta);
  let levelUps = 0;
  while (stage < maxStage && progress >= perStage) {
    progress -= perStage;
    stage++;
    levelUps++;
  }
  if (stage >= maxStage) {
    progress = Math.min(progress, perStage);
  }
  return { stage, progress, levelUps };
}
